import { useMemo } from "react";

export const createDivisionList = (eventDivisions) => eventDivisions?.map(ed => ed.division.id ).sort().reduce((result, divisionId, index) => {
    result[divisionId] = index;
    return result;
}, {});

export const useDivisionList = eventDivisions => useMemo(() => createDivisionList(eventDivisions), [eventDivisions]);
